define('Code25.CaterpartsGlobal.Segments', [
	'underscore', 'Backbone', 'jQuery', 'Utils', 'Tools'
], function (
	_, Backbone, jQuery, Utils, Tools
) {
	'use strict';

	return {
		mount: function mount(container) {

			var ProfileModel = require('Profile.Model'); //Depreciated
			if (ProfileModel.ProfileModel) {
				ProfileModel = ProfileModel.ProfileModel;
			}
			var profile = ProfileModel.getInstance();

			var ItemModel = require('Item.Model'); //Depreciated


			function showItemDetails(matrixchilditems_detail) {

				if (matrixchilditems_detail && matrixchilditems_detail.length > 0) {
					var itemid = matrixchilditems_detail[0].itemid || "";
					var end = "CSUK";
					var isCTOnly = itemid.length > 4 && itemid.substring(itemid.length - end.length) == end;

					if (isCTOnly) {
						var isCrystalTech = (profile.get("name") || "").indexOf("Crystaltech") > -1;
						return isCrystalTech;
					}
				}
				return true;

			}


			//Filter details
			ItemModel.prototype.parse = function parse(response) {


				var single_item = (response.items && response.items[0]);

				if (single_item) {

					single_item.facets = response.facets;

					var matrixchilditems_detail = single_item.matrixchilditems_detail;
					if (!matrixchilditems_detail) {
						matrixchilditems_detail = [single_item];
					}

					if (!showItemDetails(matrixchilditems_detail)) {

						single_item = null;
						response.items = [];
					}

				} else {

					if (!showItemDetails([response])) {
						response = null;
					}
				}



				return single_item ? this.sanitize(single_item) : this.sanitize(response);
			}
			//categories

			var FacetsBrowseView = require('Facets.Browse.View');

			if (FacetsBrowseView) {
				//console.log(FacetsBrowseView.prototype.getContext);
				_.extend(FacetsBrowseView.prototype, {
					initialize: _.wrap(FacetsBrowseView.prototype.initialize, function (initialize, options) {

						var res = initialize.apply(this, _.rest(arguments));
						
						// if (!this.isCategoryPage) {
						// this.sortOptions[0].id = "relevance:desc";	
						// }
						return res;

					}),

					getContext: _.wrap(FacetsBrowseView.prototype.getContext, function (getContext, options) {

						var items = this.model.get("items"), matrixchilditems_detail, hasChildren, single_item;
						for (var j = items.models.length - 1; j >= 0; j--) {

							single_item = items.models[j];

							matrixchilditems_detail = single_item.get("matrixchilditems_detail");
							if (!matrixchilditems_detail) {
								matrixchilditems_detail = [single_item.attributes];

							}
							hasChildren = matrixchilditems_detail && matrixchilditems_detail.length > 0;

							if (!showItemDetails(matrixchilditems_detail)) {
								items.models.splice(j, 1);
							}
						}
						items.length = items.models.length;


						var res = getContext.apply(this, _.rest(arguments));

						return res;

					})

				});
			}

		}
	}
});
